import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

function VerifyCode() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://wip.technicalcreatives.lk/api/users.php?action=verify-code", {
        email,
        code,
      });
      if (res.data.success) {
        navigate("/reset-password", { state: { email } });
      } else {
        alert("Invalid code");
      }
    } catch (error) {
      alert("Verification failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-1 mt-2">Enter Verification Code</h2>
        <p className="text-sm text-gray-500 mt-2 mb-6">The verification code has been sent to your email.</p>
        <input
          type="text"
          placeholder="6-digit code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="w-full px-4 py-2 border rounded mb-4"
          required
        />
        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded mb-6">
          Verify Code
        </button>
      </form>
    </div>
  );
}

export default VerifyCode;
